export const blueDeep = "#0C446F";
export const blueMedium = "#396B92";
export const greenLight = "#90DCC2";
export const greenMedium = "#55C8A1";
export const greenDeep = "#1BB581";
export const orange = "#F7685B";
export const background = "#032A48";
export const blueLink = "#2196f3"
